module.exports = {
    getStandardList:'pec/hhsPecInfo/standard/list',// 获取体质标准集合
    getHeads:'pec/hhsPecInfo/standard/headers',// 获取体质标准项表头
    getLists:'pec/hhsPecInfo/list', //获取体质列表
    getStandComponents:'pec/hhsPecInfo/standard/detail?specId=',//获取标准的控件集合
    getHhsStudentList:'child/getChildListByName.do',//获取妇保院儿童列表
    addPecInfo:'pec/hhsPecInfo/add',//添加体质数据
    addChildInfo:'child/insertChild.do',//添加儿童数据
    getPecInfo:'pec/hhsPecInfo/detail/',//获取体质数据详情
    getChildInfo:'child/getChildByID.do',//获取儿童信息
    updatePecInfo:'pec/hhsPecInfo/edit',//修改体质数据
    deletePecByIDS:'pec/hhsPecInfo/{ids}/del'
  }
  


// WEBPACK FOOTER //
// ./src/module/physique/api.js